import http from "./Http";

const exchangeToken = async (code, dealerId, redirectUri) => {
    const { data } = await http.post(`/mercadolibre/exchange-token`, {
        code,
        dealerId,
        redirectUri
    });
    return data;
};

const getConfig = async (dealerId) => {
    const { data } = await http.get(`/mercadolibre/config/${dealerId}`);
    return data;
};

const updateConfig = async (dealerId, body) => {
    const { data } = await http.put(`/mercadolibre/config/${dealerId}`, body);
    return data;
};

const getCategories = async (categoryId = null) => {
    const { data } = await http.get(
        categoryId
            ? `/mercadolibre/categories/${categoryId}`
            : `/mercadolibre/categories`
    );
    return data;
};

const generateAuthUrl = async (dealerId, redirectUri, appId) => {
    const { data } = await http.post(`/mercadolibre/auth-url`, {
        dealerId,
        redirectUri,
        appId
    });
    return data;
};

const publishItems = async (dealerId, products) => {
    const { data } = await http.post(`/mercadolibre/publish`, {
        dealerId,
        products
    }, {
        timeout: 600000 // 10 minutes for large exports
    });
    return data;
};

const MercadoLibreService = {
    exchangeToken,
    getConfig,
    updateConfig,
    getCategories,
    generateAuthUrl,
    publishItems
};

export default MercadoLibreService;
